import React, { Component } from "react";
import { monthOptions, yearOptions } from "../config";
import { getConfigDaily } from "../../dashboardSales/config";
import FlexView from "react-flexview";
import { removeNullFields } from "../../../../common/mapper";
import SimpleDDL from "../../../../../modules/SimpleDDL";
import SimpleButton from "../../../../../modules/commons/SimpleButton";
import SimpleDataTable from "../../../../../modules/SimpleDataTable";
import { fetchDataAsync } from "../../../../../Services/Utils";
import Api from "../../../../../Services/Api";
import { HttpStatus } from "../../../../common/Constants";

class DailySalesReport extends Component {
  constructor(props) {
    super(props);
    let currentDate = new Date();
    this.state = {
      month: monthOptions.find(
        (item) => item.value === currentDate.getMonth() + 1,
      ),
      year: yearOptions.find(
        (item) => item.value === currentDate.getFullYear(),
      ),
      tableConfig: getConfigDaily(),
      dataTable: [],
    };
  }

  componentDidMount = () => {
    if(this.props.search?.value){
        this.fetchData();
    }
  };

  componentDidUpdate = (prevProps, prevState, snapshot) => {
    if (
      (prevProps.doSearch !== this.props.doSearch && this.props.doSearch) ||
      this.props.search?.value !== prevProps?.search?.value
    ) {
      this.fetchData();
    }
  };

  handleChangeSearchValue = (name, value) => {
    this.setState((prevValue) => ({
      ...prevValue,
      [name]: value,
    }));
  };

  transformResponse = (data) => {
    const transformed = data.map((item) => {
      const { dataSalesDaily = {}, ...rest } = item;
      return {
        ...rest,
        ...dataSalesDaily,
      };
    });
    return transformed;
  };

  fetchData = async () => {
    try {
      this.props.triggerLoading();
      const res = await fetchDataAsync({
        asyncFn:
          Api.create("NAGAMAS_REPORT_DTO").getLaporanJualanHarianPerCabang,
        setError: this.props.setError,
        menuName:
          "Dashboard Kepala Cabang Keatas - Laporan Jual Harian By Team Leader",
        args: {
          kodeCabang: [this.props.search?.value],
          year: this.state.year?.value,
          month: this.state.month?.value,
          team: false,
          employeeIdTeamLeader: this.props.idLeader,
        },
      });
      this.props.onSuccessSearch();
      if (res.ok && res.data.status === HttpStatus.SUCCESS) {
        this.setState((prevValue) => ({
          ...prevValue,
          dataTable: this.transformResponse(res.data.data),
        }));
      }
      this.props.triggerLoading();
    } catch (error) {
      this.props.triggerLoading();
      console.log(error);
    }
  };

  handleSearch = () => {
    this.setState({
      tableConfig: getConfigDaily(
        this.state.month?.value,
        this.state.year?.value,
      ),
    });
    this.fetchData();
  };

  render() {
    return (
      <>
        <FlexView style={{ gap: "20px", alignItems: "center" }}>
          <SimpleDDL
            isClearable
            id="select_options_month"
            box="search"
            name="month"
            containerclassname="width width-250px"
            placeholder="Bulan"
            menuPosition="fixed"
            options={monthOptions}
            value={this.state.month}
            onChange={(value, { name }) =>
              this.handleChangeSearchValue(name, value)
            }
          />
          <SimpleDDL
            isClearable
            id="select_options_year"
            box="search"
            name="year"
            containerclassname="width width-250px"
            placeholder="Tahun"
            menuPosition="fixed"
            options={yearOptions}
            value={this.state.year}
            onChange={(value, { name }) =>
              this.handleChangeSearchValue(name, value)
            }
          />
          <SimpleButton
            styles={{ marginBottom: "15px" }}
            onClick={() => this.handleSearch()}
          >
            Cari
          </SimpleButton>
        </FlexView>
        <SimpleDataTable
          data={this.state.dataTable}
          columns={this.state.tableConfig}
        />
      </>
    );
  }
}

export default DailySalesReport;
